import { Component, Input, inject } from '@angular/core';

import { ClientService } from '../../../services/client.service';
import { ToastComponent } from '../../toast/toast.component';
import { Client } from '../../models/client.model';
import { contracts, dateRegexp, ee } from '../../constants';
import { setClassInvalidTpl } from '../../functions';
import { ClientContract } from '../../types';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-add-contract-modal',
  templateUrl: './add-contract-modal.component.html',
  standalone: false
})
export class AddContractModalComponent {
  toast = inject(ToastComponent);
  private clientService = inject(ClientService);


  @Input() client: Client;

  newContract: ClientContract = {
    id: 1,
    name: '',
    startDate: '', endDate: '',
    money: 0,
    cancellationDate: '', cancellationDays: 0,
    autorenewal: false
  };
  dateRegexp = dateRegexp;
  contracts = contracts;
  setClassInvalidTpl = setClassInvalidTpl;

  addArrayField(): void {
    const client: Client = {
      _id: this.client._id
    };
    this.clientService.addArrayField(client, this.newContract, 'contract')
      .pipe(finalize(() => ee.emit('getClient')))
      .subscribe({
        next: res => this.toast.setMessage('Contract added successfully', 'success'),
        error: err => this.toast.setMessage(err.error.message, 'danger'),
      });
  }

}
